export default __webpack_public_path__ + "static/media/02__o_4.eeed5514.jpg";